import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";

const ListOfTrucksReleasedFromWorkshop = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [vehicleNo, setVehicleNo] = useState("");
  const [status, setStatus] = useState("");
  const [statusValue, setStatusValue] = useState("");

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString()
  );

  const [driversList, setDriversList] = useState([]);
  const [driverName, setDriverName] = useState("");
  const [driverCode,setDriverCode] = useState("")

  const [weighBridgeNo, setWeighBridgeNo] = useState("");
  const [weighBridgeName, setWeighBridgeName] = useState("");
  const [noOfVehicles, setNoOfVehicles] = useState("");
  const [wbData, setWbData] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [gatePassNo, setGatePassNo] = useState("");

  const VehicleDepartment = useSelector(
    (state) => state?.VehicleDepartmentReducer
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "VEHICLE REG NO",
        "DRIVERNAME",
        "MAKE",
        "MODEL",
        "TRAILER NAME ATTACHED",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    // 1281
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1281`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setGatePassNo(response?.data[0]?.NEWGATEPASSNO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1264`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setWbData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1060`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then((response) => {
    //     const filterData = response?.data?.filter(
    //       (item) =>
    //         item.OT_VERIFICATION_PROCEED_TO_STATE === "SENT FOR WEIGHBRIDGE"
    //     );
    //     setDataList(filterData);
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching 1060:", error);
    //   });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        if (VehicleDepartment !== "") {
          const filterData = response?.data?.filter(
            (item) =>
              item.VEHICLESTATE === "RELEASED FROM WORKSHOP" &&
              item?.DEPARTMENT === VehicleDepartment
          );
          setVehiclesList(filterData);
         const filterWeigh = response?.data?.filter(
            (item) => item.VEHICLESTATE === "SENT FOR WEIGHBRIDGE"&&
              item?.DEPARTMENT === VehicleDepartment
          );
          setDataList(filterWeigh);
        } else {
          const filterData = response?.data?.filter(
            (item) => item.VEHICLESTATE === "RELEASED FROM WORKSHOP"
          );
          setVehiclesList(filterData);
          const filterWeigh = response?.data?.filter(
            (item) => item.VEHICLESTATE === "SENT FOR WEIGHBRIDGE"
          );
          setDataList(filterWeigh);
        }
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });
  };

  // Saving

  async function Save() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1282`,
        {
          OT_GATEPASS_NO: Number(gatePassNo),
          OT_GATEPASS_DATE: moment(date).format("YYYY/MM/DD"),
          OT_GATEPASS_TIME: currentTime,
          OT_GATEPASS_VEHICLE_REG_NUMBER: vehicleNo,
          OT_GATEPASS_DRIVER_CODE: driverCode,
          OT_GATEPASS_SENT_TO_WEIGHBRIDGE:
            status === "PROCEED TO WEIGHBRIDGE" ? 1 : 0,
          OT_GATEPASS_SENT_TO_WEIGHBRIDGE_NO: weighBridgeNo
            ? Number(weighBridgeNo)
            : 0,
          OT_GATEPASS_PROCESSED_BY: user,
          SUCCESS_STATUS: "",
          ERROR_STATUS: "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Truck Release Updated successfully`);
        await SaveVehicleState();
        console.log(`Truck Release Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Truck Release`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Truck Release `, error);
    }
  }

  async function SaveVehicleState() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNo,
          OT_VEHICLE_STATE: statusValue,
          OT_VEHICLE_STATE_DATE: moment(date).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: currentTime,
          OT_VEHICLE_PREVIOUS_STATE: "RELEASED FROM WORKSHOP",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Vehicle State Updated successfully`);
        console.log(`Vehicle State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Vehicle State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Vehicle State `, error);
    }
  }

  const handleRowClick = (value, index) => {
    setDriverCode(value?.DRIVERCODE)
    setDriverName(value["DRIVERNAME"]);
    setVehicleNo(value["VEHICLE REG NO"]);
    setShowGateIn(true);
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen p-4">
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          List Of Trucks Released From Workshop
        </h1>
        <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        />
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MODEL
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER ATTACHED ?
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ATTACHED NAME TRAILER
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["VEHICLE REG NO"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["DRIVERNAME"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MAKE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MODEL || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER ATTACHED"] === true
                    ? "YES"
                    : value["TRAILER ATTACHED"] === false
                    ? "NO"
                    : "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER NAME ATTACHED"] || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PopUp */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[280px] h-[40%] lg:w-[750px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="lg:text-3xl font-bold flex lg:justify-center justify-start">
            VEHICLES RELEASED FROM WORKSHOP
          </h1>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Gate Pass No :</p>
            <input
              className="w-16 h-8 border text-right border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={gatePassNo}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-2">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-2">Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={date?.split("T")[0]}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-2">Time :</p>
            <input
              className="w-28 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={currentTime}
              readOnly
            ></input>
          </div>

          {/* Row 2 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Driver :</p>
            <Select
              className="lg:w-64 w-64 lg:ml-4"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driverName
                  ? { value: driverName, label: driverName }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriverName(e.label);
                setDriverCode(e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversList?.map((item) => ({
                  value: item.DRIVERCODE,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>
            <p className="text-red-600 lg:ml-4">Status :</p>
            <Select
              className="w-64 lg:ml-4"
              value={
                status
                  ? { value: status, label: status }
                  : { value: "", label: "Select Status" }
              }
              onChange={(e) => {
                setStatus(e.label);
                setStatusValue(e.value);
              }}
              options={[
                { value: "", label: "Select Status" },
                {
                  label: "PROCEED TO LOAD",
                  value: "SENT TO LOAD",
                },
                {
                  value: "SENT FOR WEIGHBRIDGE",
                  label: "PROCEED TO WEIGHBRIDGE",
                },
              ]}
            ></Select>
          </div>

          {status === "PROCEED TO WEIGHBRIDGE" && (
            <>
              <div className="lg:flex lg:flex-row mt-2">
                <p className="text-red-600 lg:ml-2 mr-1">Weighbridge :</p>
                <Select
                  className="lg:w-56 w-64 lg:ml-2"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  value={
                    weighBridgeName
                      ? { value: weighBridgeName, label: weighBridgeName }
                      : { value: "", label: "Select Weighbridge" }
                  }
                  onChange={(e) => {
                    setWeighBridgeName(e.label);
                    setWeighBridgeNo(e.value);
                    const weigh = dataList?.filter(
                      (item) => item?.WEIGHBRIDGENO === e.value
                    );
                    setNoOfVehicles(weigh?.length);
                  }}
                  options={[
                    { value: "", label: "Select Weighbridge" },
                    ...wbData?.map((item) => ({
                      value: item.WBNUMBER,
                      label: item.WBNAME,
                    })),
                  ]}
                ></Select>
                <p className="text-red-600 lg:ml-2 mr-1">No Of Vehicles :</p>
                <input
                  className="w-16 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={noOfVehicles}
                  readOnly
                ></input>
              </div>
            </>
          )}
          <div className="flex justify-center mt-12">
            <button
              className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                if (!statusValue) {
                  alert("Kindly Supply Status");
                  return;
                } else if (
                  status === "PROCEED TO WEIGHBRIDGE" &&
                  !weighBridgeName
                ) {
                  alert("Kindly Supply Wighbridge");
                  return;
                } else {
                  await Save();
                  setShowGateIn(false);
                  window.location.reload();
                }
              }}
            >
              RETURN
            </button>
          </div>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default ListOfTrucksReleasedFromWorkshop;
